// @flow
import { RESORT_PRICE_REMOTE } from 'Client/cms/toolkit/constants';
import * as configQueries from 'Views/configQueries';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { buildProductArgs } from 'Utils/graphql';
import { LINE_PRODUCT_PRICE_REMOTE } from 'Utils/request/requestDictionary';

export type CMSProps = {|
  resortId: string,
|};

export type GQLProps = {|
  bookingCriteria: null | BookingCriteria,
  config: CMSContent,
  product: null | Resort,
|};

export const productPriceRemoteResolver = {
  name: RESORT_PRICE_REMOTE,
  resolve: (
    appContext: AppContext,
    props: CMSProps,
    pageContext: PageContext,
    location: RouterLocation<ProductUrlParams, {}>,
  ) => {
    const { urlParams } = location;
    const { resortId } = props;
    const productArgs = buildProductArgs(resortId, urlParams);
    const query = `query {
      product: resort(${productArgs}) {
        id
        name
        badgeIcon
        category
        comfort
        comfortLabel
        type
        isJoyview
        destination {
          country
        }
        relatedDestinations
      }
      bookingCriteria(resortId: "${resortId}") {
        departureCities {
          value
          label: name
        }
        initialTransport(resortId: "${resortId}")
        durations
      }
      config {
        ${configQueries.priceRemote()}
      }
    }`;

    return graphQLClient.runQuery(query, appContext, {
      requestName: LINE_PRODUCT_PRICE_REMOTE,
      strictErrors: false,
    });
  },
};
